import type { RefObject } from 'react'
import { getEnv } from 'swisscard/helpers/env'

export const scrollTop = () => {
  const rootElementSelector = getEnv('ROOT_ELEMENT_SELECTOR') ?? ''

  if (rootElementSelector) {
    document
      .querySelector(rootElementSelector)
      ?.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
  }
}

export const scrollToFirstError = (formElement: RefObject<HTMLFormElement>) => {
  formElement.current
    ?.querySelector('.atp-input--has-error')
    ?.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
}
